export default __webpack_public_path__ + "static/media/Selia Warren.3d96257d.jpg";